import { Typography, Stack, useTheme } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import type { PaymentPixAutomaticAdditionalInfo_subscription$key } from './__generated__/PaymentPixAutomaticAdditionalInfo_subscription.graphql.ts';

type PaymentPixAutomaticAdditionalInfoProps = {
  pixAutomatic: PaymentPixAutomaticAdditionalInfo_subscription$key;
};

const PaymentPixAutomaticAdditionalInfo = (
  props: PaymentPixAutomaticAdditionalInfoProps,
): ReactNode => {
  const { t } = useTranslation();
  const theme = useTheme();

  const pixAutomatic =
    useFragment<PaymentPixAutomaticAdditionalInfo_subscription$key>(
      graphql`
        fragment PaymentPixAutomaticAdditionalInfo_subscription on PaymentSubscription {
          additionalInfo {
            key
            value
          }
        }
      `,
      props.pixAutomatic,
    );

  if (!pixAutomatic) {
    return null;
  }

  if (!pixAutomatic.additionalInfo || pixAutomatic.additionalInfo.length <= 0) {
    return null;
  }

  return (
    <Stack sx={{ alignItems: 'center', gap: 0.5 }}>
      <Typography variant='h6' fontWeight='bold' textAlign='center'>
        {t('Additional information')}
      </Typography>
      <Stack sx={{ gap: 0 }}>
        {pixAutomatic.additionalInfo?.map((item) => {
          return (
            <Stack key={item?.key}>
              <Typography variant='body1' fontWeight='bold' textAlign='center'>
                {item?.key}
              </Typography>
              <Typography
                textAlign='center'
                sx={{ color: theme.palette.text.secondary }}
              >
                {item?.value}
              </Typography>
            </Stack>
          );
        })}
      </Stack>
    </Stack>
  );
};

export default PaymentPixAutomaticAdditionalInfo;
